(function ($) {
	'use strict';

	/**
	 * Main functionality should be in an 'init' function
	 **/
	var initEmergencyAlert = function () {

		var container = $(this);
		var $btnClose = $('.close-btn', container);
		var $body = $('body');
		var toggle = $('.cc--emergency-alert .toggle-btn');
		var content = $('#main-content');

		$btnClose.click(function () {
			var $emergencyAlert = $('.cc--emergency-alert:not(.takeover)').height();
			var $alertsWrapper = $('.alerts-wrapper').height();
			var alretHeight = $alertsWrapper - $emergencyAlert;
			$body.addClass('hide-emergency-banner');
			content.css('margin-top', alretHeight);
		});

		toggle.click(() => {
			container.toggleClass('is-open');
			alertOpen();
		});

		let alertOpen = () => {
			if (container.hasClass('is-open')) {
				$body.addClass('emergency-alert-open');
			}
			else {
				$body.removeClass('emergency-alert-open');
			}
		};

		alertOpen();
	};

	/**
	 * This is boilerplate: add a behavior to window.DP.behaviors
	 **/
	window.DP.behaviors.emergencyAlert = {
		attach: function (context) {
			$(context).find('.cc--emergency-alert').once('emergencyAlert').each(function () {
				initEmergencyAlert.apply(this);
			});
		}
	};

}(jQuery));
